/**
 * 品牌配置檔案
 * 統一管理所有品牌相關的常數和設定
 * 修改這個檔案就能更新全站的品牌名稱
 */

export const BRAND_CONFIG = {
  // 核心品牌資訊
  name: '101婚禮規劃',
  englishName: 'Wedding 101',
  shortName: '101',
  legacyName: 'Wedding Recipes', // 向下兼容，保留舊品牌名稱
  
  // 描述和標語
  tagline: '你的婚禮規劃超級幫手',
  description: '專業的婚禮規劃平台，幫助您打造完美婚禮',
  fullDescription: '你的婚禮規劃超級幫手，專注於提供簡化的數位邀請流程和智慧化婚禮規劃工具',
  
  // SEO 關鍵字
  keywords: '婚禮邀請函, 婚禮規劃, 線上邀請, RSVP, 婚宴',
  
  // 網域和聯絡資訊
  domain: '101wedding.com',
  supportEmail: 'support@101wedding.com',
  
  // UI 相關
  logo: '/WR_LOGO.svg',
  logoAlt: 'Wedding 101 Logo',
  
  // 版權和法律
  copyright: '© 2025 101婚禮規劃. All rights reserved.',
  
  // 社交媒體和 Meta 標籤
  ogSiteName: '101婚禮規劃',

  // PLG Watermark
  watermarkCTA: '快速建立你的專屬宴會邀請',
  watermarkUrl: 'https://www.101wedding.com',
} as const;

/**
 * 品牌名稱類型定義
 */
export type BrandConfig = typeof BRAND_CONFIG;